<script setup lang="ts">
import { useNavigation } from "../../composables/useNavigation";
import type { NavItem } from "../../types/navbar";

import useTracking from "@citizenm/lobby/composables/useTracking";
defineProps<{
  navigationItems: NavItem[];
  isOpen: boolean;
}>();

const { toggleSubMenu } = useNavigation();
const { trackMainNavi } = useTracking();
</script>
<template>
  <div
    :class="['navigation-drop-down', { 'navigation-drop-down--open': isOpen }]"
  >
    <nav class="navigation-drop-down__container">
      <ul>
        <li
          v-for="group in navigationItems"
          :key="group.title"
          class="navigation-drop-down__group"
        >
          <LayoutLink
            class="navigation-drop-down__link--group-header"
            color="dark"
            :link="group"
            @click="trackMainNavi(group.title)"
          />

          <ul class="navigation-drop-down__nav">
            <li
              v-for="navigationItem in group.navigationItems"
              :key="navigationItem.title"
            >
              <LayoutLink
                class="navigation-drop-down__header-link"
                color="dark"
                :link="navigationItem"
                @click="trackMainNavi(navigationItem.title)"
              />

              <ul>
                <li
                  v-for="link in navigationItem.navigationItems"
                  :key="link.title"
                >
                  <LayoutLink
                    color="dark"
                    class="navigation-drop-down__link"
                    :link="link"
                    @click="trackMainNavi(link.title)"
                  />
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  </div>
  <div
    :class="['backdrop', { 'backdrop--open': isOpen }]"
    @click="toggleSubMenu(null)"
  />
</template>

<style scoped lang="scss">
@use "@citizenm/foundation/assets/styles/mixins" as mixins;
@include mixins.reset-list;

.navigation-drop-down {
  position: absolute;
  top: var(--header-navigation-height, 80px);
  right: 0;
  left: 0;
  z-index: 1;
  height: auto;
  max-height: calc(100vh - var(--header-navigation-height, 80px));
  padding: 0 var(--spacing-6, 24px) var(--spacing-6, 24px);
  overflow: auto;
  background-color: var(--primary-white, #fff);
  visibility: hidden;

  &--open {
    visibility: visible;
  }

  &__container {
    max-width: var(--max-width, 1200px);
    margin: 0 auto;
  }

  &__nav {
    display: flex;
    flex-flow: row wrap;
    gap: var(--spacing-6, 24px);

    li {
      width: 200px;
    }
  }

  &__link {
    font-size: 14px;

    &--group-header {
      margin-bottom: 4px;
      font-size: 14px;
      line-height: 16px;
      border-bottom: 1px solid var(--color-border, #ddd);
    }
  }

  &__group {
    margin-bottom: var(--spacing-6, 24px);
  }

  &__header-link {
    font-weight: bold;
    font-size: 14px;
  }
}

.backdrop {
  position: absolute;
  top: var(--header-navigation-height, 80px);
  right: 0;
  left: 0;
  height: calc(100vh - var(--header-navigation-height, 80px));
  background-color: #00000054;
  visibility: hidden;

  &--open {
    visibility: visible;
  }
}
</style>
